export default __webpack_public_path__ + "static/media/Right.dd5b12be.svg";